import { render, staticRenderFns } from "./CTNotReading.UK.3.vue?vue&type=template&id=6456f331&scoped=true"
import script from "./CTNotReading.UK.3.vue?vue&type=script&lang=js"
export * from "./CTNotReading.UK.3.vue?vue&type=script&lang=js"
import style0 from "./CTNotReading.UK.3.vue?vue&type=style&index=0&id=6456f331&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6456f331",
  null
  
)

export default component.exports